import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Popover, TextButton } from 'wix-ui-tpa';
import { TextButtonPriority } from 'wix-ui-tpa/dist/src/components/TextButton/types';
import InfoIconSVG from './InfoIcon';
import CalendarsInfoPopoverRow from './CalendarsInfoPopoverRow';
import { st, classes } from './CalendarsInfoPopover.st.css';
import WixStylesContext from '../../../context/wixStylesContext';
var CalendarsInfoPopover = function (props) {
    var isCalendarsShown = props.isCalendarsShown, isMobile = props.isMobile, calendarsList = props.calendarsList, ariaLabel = props.ariaLabel;
    var _a = React.useState(false), shown = _a[0], setShown = _a[1];
    var t = useTranslation()[0];
    var _b = React.useContext(WixStylesContext), isWeekFontMoreTwantyFive = _b.isWeekFontMoreTwantyFive, isWeekFontMoreTwanty = _b.isWeekFontMoreTwanty, isCalendarsFontMoreTwanty = _b.isCalendarsFontMoreTwanty, isHeaderFontMoreTwanty = _b.isHeaderFontMoreTwanty;
    var width = window.innerWidth;
    var smallSize = width < 800 ||
        (isWeekFontMoreTwantyFive && window.innerWidth < 820) ||
        (isCalendarsFontMoreTwanty && isWeekFontMoreTwantyFive) ||
        (isHeaderFontMoreTwanty && isWeekFontMoreTwanty) ||
        (isCalendarsFontMoreTwanty && isWeekFontMoreTwanty) ||
        (window.innerWidth < 820 &&
            isHeaderFontMoreTwanty &&
            isCalendarsFontMoreTwanty);
    var label = smallSize ? '' : t('calendars_info_popup');
    var handleKeyUp = function (e) {
        if (e.key === 'Enter') {
            setShown(!shown);
        }
        if (e.key === 'Escape') {
            setShown(false);
        }
    };
    return (React.createElement("div", { className: st(classes.CalendarsContainer, {
            isCalendarsShown: isCalendarsShown,
            smallSize: smallSize,
            isMobile: isMobile,
        }) },
        React.createElement(Popover, { placement: "top", moveBy: isMobile ? { y: 5 } : { y: -3 }, className: st(classes.root, { isMobile: isMobile }), shown: shown, onClickOutside: function () { return (shown ? setShown(false) : null); } },
            React.createElement(Popover.Element, null, isMobile ? (React.createElement("div", { style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                }, onClick: function () { return setShown(!shown); } },
                React.createElement(InfoIconSVG, { isMobile: true }))) : (React.createElement("div", { style: {
                    height: '100%',
                    padding: '8px 5px',
                    borderRadius: '5px',
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                }, onKeyUp: handleKeyUp, tabIndex: 3, onClick: function () { return setShown(!shown); } },
                React.createElement(TextButton, { "aria-label": ariaLabel, role: 'button', className: st(classes.Calendars, { isMobile: isMobile }), priority: TextButtonPriority.secondary, prefixIcon: React.createElement(InfoIconSVG, { isMobile: false }) }, label)))),
            React.createElement(Popover.Content, null,
                React.createElement("div", { style: { padding: '8px 28px 0 18px' } }, calendarsList
                    .filter(function (c) {
                    return c.selected &&
                        (c.accessRole === 'reader' ||
                            c.accessRole === 'freeBusyReader' ||
                            c.accessRole === 'writer');
                })
                    .map(function (calendar) { return (React.createElement(CalendarsInfoPopoverRow, { calendar: calendar, key: calendar.idCrypt })); }))))));
};
export default CalendarsInfoPopover;
//# sourceMappingURL=CalendarsInfoPopover.js.map